<template>
  <footer class="bg-white">
    <div class="container mx-auto px-4 py-6 text-center text-gray-900">
      <p>
        This website was built using
        <strong>
          <a href="https://getbiew.com/">Biew</a>
        </strong>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>
